import React from 'react';

const RoomsPage = () => (
  <div>
    <h1>Rooms Page</h1>
  </div>
);

export default RoomsPage;
